import * as Yup from "yup";
const specificProjectValidationSchema = Yup.object({
  // items: Yup.array().required("This field is required"),
  delivery_method: Yup.string().required("This field is required"),
  // item_category: Yup.string().required("This field is Required"),
  // project: Yup.string().required("This field is Required"),
});

export { specificProjectValidationSchema };
